<template>
  <div class="enroll-exam-student-result-desc">
    正式生人数&nbsp;<span class="theme-text">{{resultDesc.sumNum}}</span>&nbsp;人&nbsp;&nbsp;&nbsp;&nbsp;
    已安排&nbsp;<span class="warning">{{resultDesc.resultSumNum}}</span>&nbsp;人&nbsp;&nbsp;&nbsp;&nbsp;
    考场数&nbsp;<span class="theme-text">{{resultDesc.roomNum}}</span>&nbsp;个&nbsp;&nbsp;&nbsp;&nbsp;
    已安排&nbsp;<span class="warning">{{resultDesc.resultRoomNum}}</span>&nbsp;个
  </div>
</template>

<script>
import globalEvent from '../../../../../../../../constants/globalEvent'
import routeConfig from '../../../../../../../../constants/routeConfig'

export default {
  name: 'EnrollExamStudentResultDesc',
  data () {
    return {
      resultDesc: {}
    }
  },
  mounted () {
    this.bindEvent()
    this.queryResultsDesc()
  },
  beforeDestroy () {
    this.unbindEvent()
  },
  activated () {
    this.queryResultsDesc()
  },
  methods: {
    queryResultsDesc () {
      this.$ajax({
        url: '/workspace/manager/enrolling/exam/student/query/results/desc',
        method: 'post',
        data: this.$qs.stringify({
          studentType: 'EMBA'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.resultDesc = response.data['resultDesc']
              break
            }
            default: {
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      })
    },
    bindEvent () {
      this.$bus.$on(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.$attrs[routeConfig.DataGrid.param]}`, this.queryResultsDesc)
    },
    unbindEvent () {
      this.$bus.$off(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.$attrs[routeConfig.DataGrid.param]}`, this.queryResultsDesc)
    }
  }
}
</script>

<style lang="scss" scoped>
.enroll-exam-student-result-desc {
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  .warning{
    color: #e6a23c;
  }
}
</style>
